import AuroraD1 from './Aurora D.webp'
import AuroraD2 from './Aurora D.webp'


const AuroraDimages =[
AuroraD1,AuroraD2
]

export default AuroraDimages;